import { render, staticRenderFns } from "./customerSettings.vue?vue&type=template&id=fb214f42&scoped=true"
import script from "./customerSettings.vue?vue&type=script&lang=js"
export * from "./customerSettings.vue?vue&type=script&lang=js"
import style0 from "./customerSettings.vue?vue&type=style&index=0&id=fb214f42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb214f42",
  null
  
)

export default component.exports